// extracted by mini-css-extract-plugin
export default {"tncContainer":"TNC_tncContainer__cf7As","accordianContainer":"TNC_accordianContainer__Y0cX7","headingContainer":"TNC_headingContainer__rLWlX","backBtn":"TNC_backBtn__y-mRo"};